
        var result = require("!!../../../../node_modules/css-loader/index.js!./settings-cashreg.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-cashreg/settings-cashreg.component.css
// module id = 2376
// module chunks = 1